import { render } from "./UploadNote.vue?vue&type=template&id=680c2d38"
import script from "./UploadNote.vue?vue&type=script&lang=js"
export * from "./UploadNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__